import React, { useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import foodGIF from "../../assets/food/food.gif";
import { ProceedButton } from "src/styled-components/generalTags";
import cross from "../../assets/flexi/cross.svg";
import "./superticketPopup.css"

function SuperTicketRules({ visible, content, setVisible }) {
  const theme = localStorage.getItem("theme");
  const isMobile = window.matchMedia("(max-width: 575px)").matches;  
  const sortByPriority = (arr) => {
    return arr.sort((a, b) => a.priority - b.priority);
  };
  const sortedRules = content?.rules ? sortByPriority(content?.rules) : [];
  useEffect(() => {

  }, [visible]);
  
  return (
    <div>
      <Sidebar
        visible={visible}
        showCloseIcon={false}
        position={isMobile ? "bottom" : "right"}
        onHide={() => {
          setVisible(false);
        }}
        className="flexi-terms-conds"
        dismissable={true}
      >
        {!content?.fb?<>
        <div className="terms-flexi-head">
          <div className="st-terms-heading">
            <h4>Rules & Exceptions</h4>
          </div>
          <div className="flexi-cross show-in-desktop-view">
            <img src={cross} alt="" className="img-fluid" onClick={() => {
                    setVisible(false);
                  }}/>
          </div>
        </div>
        <div className="divider-flexi"></div>
        </>
        :""}
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className={`flexi-terms-list ${content?.fb?"p-4":""}` }
            >            
            <div className="st-tandc-content">
              <ul>
              {sortedRules.length > 0 ? (
            sortedRules.map((rule, index) => (
              <li key={index}>
                <strong>{rule.header && `${rule.header}:`}</strong> {rule.text}
              </li>
            ))
          ) : (
            <li>No rules available</li>
          )}

                </ul>

            </div>
              <div className="accept-viww-flexi">
                <ProceedButton className="how-it-okay" onClick={() => {
                    setVisible(false);
                  }}>
                  Accept
                </ProceedButton>
              </div>
            </div>
          </div>
        </div>
      </Sidebar>
    </div>
  );
}

export default SuperTicketRules;
